import * as fade from './ui-fade.js'
import * as messageBox from './ui-message-box.js'
import * as buttonSprite from './ui-button-sprite.js'

export default async function procStack(params) {
    const { app, w, h, cards } = params;

    // Random cards order
    cards.forEach(card => card.__indexSort = Math.random());
    cards.sort((a, b) => a.__indexSort - b.__indexSort);
    cards.forEach((card, i) => card.__indexSort = i);

    // Random cards direction
    cards.forEach(card => card.__isUpright = Math.trunc(Math.random() * 2) === 0);

    //console.log(cards.map(x => `${x.__id}: ${x.__isUpright}`).join('\n'));

    // Stack cards
    const baseY = h * 0.8;
    cards.forEach((card, i) => {
        card.x = w / 2;
        card.y = baseY - i * 8;
        app.stage.addChild(card);
    });

    await fade.fadeIn(app);

    // Move cards
    const pArr = cards.map((card, i) => 
        anime({targets: card, y: baseY - i * 2 , duration: 500, easing: 'linear'}).finished
    );
    await Promise.all(pArr);

    // Show message
    const text = 'シャッフルを開始します\nカードの山をタップしてください';
    const mes = messageBox.gen(app, text)
    mes.y = h * 0.15;

    // Top card
    await new Promise(resolve => {
        const sprite = cards.at(-1);
        buttonSprite.onClick(sprite, () => {
            buttonSprite.offClick(sprite);
            resolve();
        })
    });

    // After click top card
    mes.destroy()
}
